import { observable, runInAction } from "mobx"

import { Model } from "@/lib/Model.ts"

import type { ScrollableModel } from "@/components/Scrollable/ScrollableModel.ts"
import type { IObservableValue } from "mobx"


export class DropdownWithFilterModel extends Model {
  private timeoutId?: ReturnType<typeof setTimeout>

  readonly isFirstLoad: IObservableValue<boolean>

  constructor(private readonly scrollableModel: ScrollableModel) {
    super("DropdownWithFilterModel")

    this.isFirstLoad = observable.box(true)

    this.lifetime.add(() => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
    }, "DropdownWithFilterModel:clearTimeout")
  }

  readonly onInputValueChange = (inputValue: string) => {
    this.scrollableModel.scrollToTop()

    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = undefined
    }

    if (this.isFirstLoad.get() && inputValue !== "") {
      this.timeoutId = setTimeout(() => {
        runInAction(() => {
          this.isFirstLoad.set(false)
        })
      }, 1500)
    }

    if (inputValue === "") {
      runInAction(() => {
        this.isFirstLoad.set(true)
      })
    }
  }
}